const renderTitleNames = (users) => {
  if (users?.length === 1) {
    return (<b>{users[0]?.displayName}</b>)
  } else if (users?.length === 2) {
    return (<><b>{users[0]?.displayName}</b> and <b>{users[1]?.displayName}</b></>)
  } else if (users?.length > 2) {
    return (<><b>{users[0]?.displayName}</b> and {users.length - 1} others</>)
  }
}

const POST_DISPLAY = new Set(['reply', 'mention'])

export { renderTitleNames, POST_DISPLAY }
